var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/facet-option.j2"] = require( "macros/facet-option.j2" );
dependencies["facets/custom-price-range.j2"] = require( "facets/custom-price-range.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-price-facet.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
env.getTemplate("macros/facet-option.j2", false, "category/templates/facets/category-price-facet.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("facetOption")) {
var t_4 = t_1.facetOption;
} else {
cb(new Error("cannot import 'facetOption'")); return;
}
context.setVariable("facetOption", t_4);
output += "\n\n";
var t_5;
t_5 = (lineno = 5, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.showCustomPriceFacet",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("shouldDisplayCustomPriceRange", t_5, true);
if(frame.topLevel) {
context.setVariable("shouldDisplayCustomPriceRange", t_5);
}
if(frame.topLevel) {
context.addExport("shouldDisplayCustomPriceRange", t_5);
}
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"refinements");
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("refinement", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
if(env.getFilter("length").call(context, runtime.memberLookup((t_9),"refinement_range")) > 0 && !runtime.memberLookup((t_9),"isCustomPriceRange")) {
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((t_9),"refinement_range")),0);
frame.set("lowPrice", t_10, true);
if(frame.topLevel) {
context.setVariable("lowPrice", t_10);
}
if(frame.topLevel) {
context.addExport("lowPrice", t_10);
}
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((t_9),"refinement_range")),1);
frame.set("highPrice", t_11, true);
if(frame.topLevel) {
context.setVariable("highPrice", t_11);
}
if(frame.topLevel) {
context.addExport("highPrice", t_11);
}
var t_12;
t_12 = (runtime.contextOrFrameLookup(context, frame, "showResultsCount")?runtime.memberLookup((t_9),"count"):0);
frame.set("refinementsCount", t_12, true);
if(frame.topLevel) {
context.setVariable("refinementsCount", t_12);
}
if(frame.topLevel) {
context.addExport("refinementsCount", t_12);
}
output += runtime.suppressValue((lineno = 17, colno = 20, runtime.callWrap(t_4, "facetOption", context, [runtime.contextOrFrameLookup(context, frame, "category"),t_9,runtime.memberLookup((t_9),"refinement_display_name"),"price",runtime.memberLookup((t_9),"refinement_display_name"),runtime.makeKeywordArgs({"listItemDataAttributes": "data-facet-value-min=\"" + "" + runtime.contextOrFrameLookup(context, frame, "lowPrice") + "" + "\" data-facet-value-max=\"" + "" + runtime.contextOrFrameLookup(context, frame, "highPrice") + "" + "\"","gaAttributes": (lineno = 19, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 19, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"filter by price",runtime.memberLookup((t_9),"refinement_display_name"),{"no_of_results": runtime.memberLookup((t_9),"count")}])),"additionalClasses": "js-clear-custom-price-facet","refinementsCount": runtime.contextOrFrameLookup(context, frame, "refinementsCount")})])), env.opts.autoescape);
;
}
else {
if(runtime.memberLookup((t_9),"isCustomPriceRange") && runtime.contextOrFrameLookup(context, frame, "shouldDisplayCustomPriceRange")) {
env.getTemplate("facets/custom-price-range.j2", false, "category/templates/facets/category-price-facet.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
})});
}
;
}
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-price-facet.j2"] , dependencies)